var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAudioIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_7",
    x: 0,
    y: 0,
    width: 76,
    height: 76,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 3,
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SON",
    transform: "translate(6 6)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "SON-2",
    "data-name": "SON"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -6, -6)",
    filter: "url(#Ellipse_7)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_7-2",
    "data-name": "Ellipse 7",
    cx: 29,
    cy: 29,
    r: 29,
    transform: "translate(6 6)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "music-and-multimedia_1_",
    "data-name": "music-and-multimedia (1)",
    transform: "translate(12.727 13.848)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1342",
    "data-name": "Path 1342",
    d: "M18.833,16.1a1.077,1.077,0,0,0-1.143.13L7.181,24.633H2.16A2.164,2.164,0,0,0,0,26.794v8.642A2.163,2.163,0,0,0,2.16,37.6H7.181L17.688,46a1.082,1.082,0,0,0,1.145.127,1.078,1.078,0,0,0,.611-.972V17.072A1.084,1.084,0,0,0,18.833,16.1Z",
    transform: "translate(0 -15.99)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1343",
    "data-name": "Path 1343",
    d: "M343.591,122.563a1.081,1.081,0,1,0-1.519,1.538,8.617,8.617,0,0,1,0,12.2,1.079,1.079,0,1,0,1.519,1.534,10.776,10.776,0,0,0,0-15.274Z",
    transform: "translate(-318.679 -115.078)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1344",
    "data-name": "Path 1344",
    d: "M388.709,77.438a1.081,1.081,0,1,0-1.523,1.534,12.891,12.891,0,0,1,0,18.3,1.081,1.081,0,0,0,1.523,1.534,15.056,15.056,0,0,0,0-21.365Z",
    transform: "translate(-360.749 -72.997)",
    fill: "#868686"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudioIcon);
export default __webpack_public_path__ + "static/media/audio-icon.b9c20053.svg";
export { ForwardRef as ReactComponent };